export default {
    CustomerList: {
        ChooseCustomer: 'Escolha um Cliente',
    },

    Customer: {
        SafesOnline: 'Cofres online',
        CurrentBalance: 'Saldo atual',
        DailySales: 'Vendas Diárias',
        ActiveWarnings: 'Alarmes ativos',
        Of: 'OF',
        In: 'EM',
        Branches: 'FILIALIS',
    },

    Branch: {
        ExportTransactions: "Exportar Transações",
        ManageOperators: "Gerir Operadores",
        ShowOnMap: "Mostrar no Mapa",
        CurrentBalance: "Saldo Atual",
        DailySales: 'Vendas Diárias',
    },

    BranchList: {
        Name: 'Nome',
        Status: 'Estado',
        BalanceAmount: 'Saldo',
        BalanceCurrency: 'Moeda do Saldo',
        LastBalance: 'Atualizado',
        Branches: 'Filiais',
    },

    Chart: {
        Sales: 'Vendas',
        Pickup: 'Recolhas',
        Balance: 'Saldo',
        Difference: 'Diferença',
        DepositsAndPickups: 'Depósitos & Recolhas',
        NoDataAvailable: 'Sem dados disponíveis'
    },

    ChartDenominations: {
        Deposited: 'Depositado',
        Recyclable: 'Reciclado',
        Denominations: 'Espécies',
        NoDataAvailable: 'Sem dados disponíveis'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Entrada de Vendas processadas',
        UnprocessedSales: 'Entrada de vendas não processadas',
        SalesOut: 'Vendas saída',
        SalesPerHour: 'Vendar por hora'
    },

    CustomerHeader: {
        ShowOnMap: 'Mostrar no Mapa',
        Branches: 'Filiais',
        Branch: 'Filial',
    },

    DeviceStatus: {
        AllOk: 'Tudo Ok',
    },

    DeviceStatusList: {
        Safes: 'Cofres',
    },

    ExportForm: {
        ExportTransactions: 'Exportar Transações',
        Cancel: 'Cancelar',
        Export: 'Exportar',
        FromDate: 'Data De',
        Time: 'Horas',
        EndDate: 'Data Fim'
    },

    ForgotPasswordForm: {
        EmailAddress: 'Endereço de E-mail',
        Submit: 'Enviar e-mail',
        ErrorMessage: 'Nós não conseguimos enviar o seu pedido para o servidor'
    },

    Drawer: {
        Dashboard: 'Painel de Controle',
        SwitchCustomer: 'Mudar cliente',
        MyProfile: 'O meu perfil',
        Logout: 'Terminar Sessão'
    },

    OperatorForm: {
        UserId: 'Id de Utilizador',
        FirstName: 'Primeiro Nome',
        LastName: 'Último Nome',
        Pin: 'Pin',
        Save: 'Gravar',
        Delete: 'Apagar'
    },

    OperatorList: {
        AddOperator: 'Adicionar Operador',
        Operators: 'Operadores'
    },


    Profile: {
        Profile: 'Perfil',
        Name: 'Nome',
        Language: 'Idioma',
        Password: 'Senha',
        ConfirmPassword: 'Confirmar Senha',
        Update: 'Atualizar'
    },

    ResetPasswordForm: {
        NewPassword: 'Nova Senha',
        ConfirmPassword: 'Confirmar Senha',
        Submit: 'Submeter'
    },

    InviteUserForm: {
        InviteHeader: 'Utilizador convidado',
        InviteText: 'Por favor preencha os dados do seu perfil e carregue em Guardar para conseguir entrar.',
        Name: 'Nome',
        Language: 'Língua',
        NewPassword: 'Nova Senha',
        ConfirmPassword: 'Confirme a Senha',
        Submit: 'Guardar'
    },

    TransactionList: {
        Type: 'Tipo',
        Operator: 'Operador',
        When: 'Quando',
        Amount: 'Montante',
        Currency: 'Moeda',
        Transactions: 'Transações',
        SalesDay: 'DiaDeVendas',
        HoverDeposit: 'Vendas entrada',
        HoverSalesIn: 'Vendas entrada',
        HoverSalesOut: 'Vendas saída',
        HoverManualDeposit: 'Depósito Manual',
        HoverCollection: 'Coleção',
        HoverCollectionNotes: 'Coleção de notas',
        HoverCollectionCoins: 'Coleção de moedas',
        HoverCollectionEnvelope: 'Coleção de depósitos manuais',
        HoverCollectionOK: 'Coleção confirmada',
        HoverCollectionNotesOK: 'Coleção de notas confirmada',
        HoverCollectionCoinsOK: 'Coleção de moedas confirmada',
        HoverCollectionEnvelopeOK: 'Coleção de depósitos manuais confirmada',
        HoverCollectionNOK: 'Diferença na coleção',
        HoverCollectionNotesNOK: 'Diferença na coleção de notas',
        HoverCollectionCoinsNOK: 'Diferença na coleção de moedas',
        HoverCollectionEnvelopeNOK: 'Diferença na coleção de depósitos manuais',
        HoverDrain: 'Remoção',
        HoverRefill: 'Reabastecer',
        HoverExchange: 'Trocos',
        HoverExchangeIn: 'Trocos entrada',
        HoverExchangeOut: 'Trocos saída',
        HoverCounterfeit: 'Contrafeita',
        HoverInternal: 'Transação interna',
        HoverNOP: 'Sem operação'
    },

    TransactionDayList: {
        Date: "Data",
        Sales: "Vendas",
        Pickup: "Recolha",
        Balance: "Saldo",
        TransactionDays: "DiasDeTransação"
    },

    TransactionDay: {
        Date: "Data",
        Sales: "Vendas",
        Pickup: "Recolha",
        Balance: "Saldo",
        TransactionDays: "DiasDeTransação"
    },

    TransactionDatePicker: {
        Date: 'Data'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/pt.js